import React from "react";
import { Link } from "react-router-dom";

const Banner = () => {

  return (
    <div className="hero-wrapper" id="index">
      <div className="hero-container">
        <div className="right-image">
          <div className="hero">
            <h1 className="hero-title">
              Dress Up, But STILL.
            </h1>
            <p className="hero-subtitle">Shoes for wherever the night takes you.</p>

            <Link to="/shop" className="button">
              <span>DISCOVER →</span>
            </Link>

            <div className="sticky-cta">
              <div className="sticky-cta-content">
                <span className="sticky-cta-text">
                  Footwear designed for all-day comfort.
                </span>

                <Link to="/shop" className="sticky-cta-button">
                  Shop Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
